import React, { useContext } from 'react';
import { useDevice } from '@bonnet/next/device';
import ConfigContext from '@/contexts/ConfigContext';

import {
    AdsContainer,
} from '..';

function HomePageAdsContainer() {
    const {
        site: {
            adsLazyLoadingOffset,
        },
    } = useContext(ConfigContext);
    const device = useDevice();
    const isMobile = device.is.xs;

    return (
        <AdsContainer
            slotId={isMobile ? 'extra-adDiv-react-2' : 'extra-adDiv-react'}
            showAd
            pos="a"
            adSizes={isMobile ? [[320, 50], [320, 90]] : [[728, 90]]}
            adsLazyLoadingOffset={adsLazyLoadingOffset}
            showPlaceholder
        />
    );
}

export default HomePageAdsContainer;
